import { Col, Row } from 'antd';
import { SubMatter_COLUMNS } from './columns';
import './index.scss';

export const useSubjectMatter = ({ details, handleClickEditBtn }: any) => {
  const subMatterComponent = (
    <div className="pc-pro-container">
      <div className="pc-sub-tit">
        <div className="pc-sub-tit-text">标的物</div>
        {details?.deleteStatus ? null : (
          <a className="pc-detail-edit-btn" onClick={handleClickEditBtn}>
            编辑
          </a>
        )}
      </div>
      <Row gutter={[18, 18]}>
        {SubMatter_COLUMNS.map((x, index) => {
          return (
            <Col span={10} key={index} className="pc-info-flex">
              <div className="pc-info-label">{x.title} :</div>
              <div>{x.render ? x.render(details) : details[x.key] || ''}</div>
            </Col>
          );
        })}
      </Row>
    </div>
  );

  return {
    subMatterComponent
  };
};
